
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/wishlist",
      function () {
        return require("private-next-pages/account/wishlist/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/wishlist"])
      });
    }
  